module.exports = "pegasus/assets/themelp1/product/100.png";